import {BijbModule} from '../../models/bijb-module';
import {snakify} from '../snakify';
import {camelize} from '../camelize';
import {ISerializable} from 'cerialize';

export const BijbModuleTransformer: ISerializable = {
  Serialize(value: BijbModule): string {
    return snakify(BijbModule[value]);
  },
  Deserialize(json: any): any {
    if (json) {
      const valueName = camelize(json, true);
      return BijbModule[valueName];
    }
    return null;
  }
};
